import { offlineActionCreator } from "actions/lib";

import {
  AppUpdateStatus,
  REFRESH_INTERVAL,
  SERVER_HEARTBEAT,
  SET_LAST_KNOWN_VERSION,
} from "constants/actionTypes";

export function updateRefreshInterval(refreshIntervalMs) {
  return {
    type: REFRESH_INTERVAL.ACTION,
    refreshIntervalMs,
  };
}

const urlCreator = () => `/v2/heartbeat/`;

export const ServerHeartbeatAction = offlineActionCreator(
  SERVER_HEARTBEAT,
  () => {},
  urlCreator,
  false,
);

export function appUpdateLogoutRequired() {
  return {
    type: AppUpdateStatus.LOGOUT_REQUIRED,
  };
}

export function appUpdateRefreshRequired() {
  return {
    type: AppUpdateStatus.REFRESH_REQUIRED,
  };
}

export function appUpdateRefreshOptional() {
  return {
    type: AppUpdateStatus.REFRESH_OPTIONAL,
  };
}

export function appUpdateInvisible() {
  return {
    type: AppUpdateStatus.INVISIBLE,
  };
}

export function appUpdateComplete() {
  return {
    type: AppUpdateStatus.COMPLETE,
  };
}

export function setLastKnownVersion(version) {
  return {
    type: SET_LAST_KNOWN_VERSION,
    version,
  };
}
